import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        nic: '',
        nombre: '',
        direccion: '',
        id_departamento: '',
        id_municipio: '',
        id_tipo_facturacion: '',
        tarifa: '',
        valor_impuesto: '',
        fecha_anulacion: '',
        departamentos: [],
        municipios: [],
        errores: [],
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { nic, nombre, direccion, id_departamento, id_municipio, id_tipo_facturacion, tarifa, valor_impuesto, fecha_anulacion } = this.state;
        var errores = [];
        if (!nic) { errores.push("error_nic"); }
        if (!nombre) { errores.push("error_nombre"); }
        if (!direccion) { errores.push("error_direccion"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!id_tipo_facturacion) { errores.push("error_id_tipo_facturacion"); }
        if (!tarifa) { errores.push("error_tarifa"); }
        if (!valor_impuesto) { errores.push("error_valor_impuesto"); }
        if (!fecha_anulacion) { errores.push("error_fecha_anulacion"); }
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            nic: nic,
            nombre: nombre,
            direccion: direccion,
            id_departamento: id_departamento,
            id_municipio: id_municipio,
            id_tipo_facturacion: id_tipo_facturacion,
            tarifa: tarifa,
            valor_impuesto: valor_impuesto,
            fecha_anulacion: fecha_anulacion,
            id_usuario: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("clientes_especiales/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Clientes Especiales!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterClientesEspeciales");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Clientes Especiales!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('id_departamento').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipios: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, departamentos: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { departamentos, municipios, nic, nombre, direccion, id_departamento, id_municipio, id_tipo_facturacion, tarifa, valor_impuesto, fecha_anulacion } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE CLIENTES ESPECIALES</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="nic">NIC</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nic")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nic" id="nic" value={nic} placeholder="NIC" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el NIC</small>
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nombre" id="nombre" value={nombre} placeholder="Nombre" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Cliente Especial</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="direccion">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_direccion")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="direccion" id="direccion" value={direccion} placeholder="Dirección" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Dirección</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="id_departamento">Departamento</label>
                                                    <select name="id_departamento"
                                                        id="id_departamento"
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.cargarMunicipios(e);
                                                            this.cambioValor(e)
                                                        }}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentos.map((itemDepartamentos) => (
                                                                <option key={itemDepartamentos.ID_DEPARTAMENTO} value={itemDepartamentos.ID_DEPARTAMENTO}>{itemDepartamentos.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="id_municipio">Municipio</label>
                                                    <select name="id_municipio" id="id_municipio"
                                                        className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Municipio</option>
                                                        {
                                                            municipios.map((item) => (
                                                                <option key={item.ID_MUNICIPIO} value={item.ID_MUNICIPIO}>{item.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN TIPO FACTURACIÓN / TARIFA</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="id_tipo_facturacion">Tipo Facturación</label>
                                                    <select name="id_tipo_facturacion"
                                                        id="id_tipo_facturacion"
                                                        className={((this.verificarError("error_id_tipo_facturacion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione Tipo Facturación</option>
                                                        <option value="2">SALARIO</option>
                                                        <option value="3">UVT</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Facturación</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="tarifa">Tarifa</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_tarifa")) ? "is-invalid" : "") + " form-control form-control-sm"} type="number" name="tarifa" id="tarifa" value={tarifa} placeholder="Tarifa" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Tarifa</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_impuesto">Valor Impuesto</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_tarifa")) ? "is-invalid" : "") + " form-control form-control-sm"} type="number" name="valor_impuesto" id="valor_impuesto" value={valor_impuesto} placeholder="Valor Impuesto" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Impuesto</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_anulacion">Fecha Anulación</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_anulacion" id="fecha_anulacion" value={fecha_anulacion}
                                                            className={((this.verificarError("error_fecha_anulacion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA ANULACIÓN" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Anulación</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Cliente Especial</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterClientesEspeciales"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;